import { GroupMember } from "~/common/Store/models/ProductListing";
import { User } from "~/common/Store/models/User";
import getLowestPrice from "./getLowestPrice";
import isActiveSale from "./isActiveSale";

export default (
  groupMembers: GroupMember[],
  user: User,
  originalProductId?: string,
) => {
  let lowestPriceGroupMember = groupMembers[0];
  let lowestPrice = Infinity;

  if (groupMembers.length > 1) {
    groupMembers.forEach((member) => {
      const {
        price,
        showBelowMinimumAdvertisedPriceForLoggedInCustomers,
        showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
      } = member;

      const onSale = isActiveSale(price);

      const memberPrice = getLowestPrice(
        price,
        user,
        onSale,
        showBelowMinimumAdvertisedPriceForLoggedInCustomers,
        showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
      );

      if (memberPrice < lowestPrice) {
        lowestPrice = memberPrice;
        lowestPriceGroupMember = member;
      } else if (memberPrice === lowestPrice) {
        if (member.itemNumber === originalProductId) {
          lowestPriceGroupMember = member;
        }
      }
    });
  }

  return lowestPriceGroupMember;
};
